import {
  useEntity,
  usePalette as useGetPaletteFromEntity,
} from '@uswitch/ev-utils/lib/context/selectors'
import {
  Palette,
  PaletteProvider,
  usePalette as useGetPaletteFromContext,
} from '../../elements/palette'
import { useThemeUI } from 'theme-ui'

const getDefaultComponentPalette = (component = '', theme) => {
  const components = ['elements', 'modules', 'compounds']
  const componentName = component?.toLowerCase().split(' ').join('-')

  const styles = Object.values(
    Object.fromEntries(Object.entries(theme).filter(([key]) => components.includes(key))),
  ).reduce((acc, val) => ({ ...acc, ...val }), {})

  return styles[componentName]?.paletteWrapper || {}
}

const PaletteWrapper = ({ children, palette: entity, ...props }) => {
  const { theme } = useThemeUI()
  const paletteFromProp = useGetPaletteFromEntity(useEntity(entity))
  const paletteFromContext = useGetPaletteFromContext()
  const defaultPalette = getDefaultComponentPalette(props?.componentName, theme)
  const customPalette = entity?.sys ? paletteFromProp : entity || paletteFromContext
  const palette = { ...defaultPalette, ...customPalette }

  return (
    <PaletteProvider value={palette}>
      <Palette
        as='div'
        px={{
          background: 'background',
          backgroundColor: 'backgroundColor',
          color: 'textColor',

          'h1, h2, h3, h4, h5, h6, a, strong, b': {
            color: 'accentTextColor',
          },
        }}
      >
        {children}
      </Palette>
    </PaletteProvider>
  )
}

export default PaletteWrapper
